export const PURPOSE_REWARD_LETTER                    = 0;
export const PURPOSE_RESTORE_PAYMENT_BY_SKU           = 1;
export const PURPOSE_REWIND_STORY_TO_QUEST            = 2;
export const PURPOSE_REWIND_M3_MAIN_SEQUENCE          = 3;
export const PURPOSE_FORCE_SPECIAL_OFFER              = 4;
export const PURPOSE_FORCE_APPLY_MIGRATION            = 5;
export const PURPOSE_TRANSFER_CLUB_OWNERSHIP_RECEIVED = 6;
export const PURPOSE_TRANSFER_CLUB_OWNERSHIP_LOST     = 7;
export const PURPOSE_FOLLOWING_LINK                   = 8;
export const PURPOSE_FOR_VIP                          = 9;

//-----------------------------------------------------------------------------

const MGM_TOPUP_ITEM_GIVER = 1;
const MGM_PAYMENT_FIXER    = 2;

/**
 * @param {number} serviceId
 * @returns {string}
 */
export function getPendingCreatorServiceName(serviceId) {
  switch(serviceId) {
    case MGM_TOPUP_ITEM_GIVER: return 'MY.GAMES TopUp выдача предмета';
    case MGM_PAYMENT_FIXER:    return 'MY.GAMES аварийная выдача';
    default:
      return `Сервис ${serviceId}`;
  }
}

//-----------------------------------------------------------------------------
